export default {
  mounted() {
    if (this.el.dataset.admin !== "true") return

    let touchDragEl = null
    let touchGhost = null
    let touchStartX = 0
    let touchStartY = 0
    let touchStarted = false

    // --- Mouse/pointer drag ---
    this.el.addEventListener("dragstart", e => {
      const card = e.target.closest(".kanban-card")
      if (!card || card.dataset.pending === "true") return
      e.dataTransfer.setData("text/plain", JSON.stringify({
        number: card.dataset.number,
        from: card.dataset.status,
      }))
      e.dataTransfer.effectAllowed = "move"
      card.classList.add("opacity-40", "scale-95")
      this._dragging = card
    })

    this.el.addEventListener("dragend", () => {
      if (this._dragging) {
        this._dragging.classList.remove("opacity-40", "scale-95")
        this._dragging = null
      }
      this.el.querySelectorAll(".kanban-drop-active").forEach(el =>
        el.classList.remove("kanban-drop-active")
      )
    })

    this.el.addEventListener("dragover", e => {
      const zone = e.target.closest(".kanban-drop-zone")
      if (!zone) return
      e.preventDefault()
      e.dataTransfer.dropEffect = "move"
      if (!zone.classList.contains("kanban-drop-active")) {
        this.el.querySelectorAll(".kanban-drop-active").forEach(el =>
          el.classList.remove("kanban-drop-active")
        )
        zone.classList.add("kanban-drop-active")
      }
    })

    this.el.addEventListener("dragleave", e => {
      const zone = e.target.closest(".kanban-drop-zone")
      if (zone && !zone.contains(e.relatedTarget)) {
        zone.classList.remove("kanban-drop-active")
      }
    })

    this.el.addEventListener("drop", e => {
      e.preventDefault()
      this.el.querySelectorAll(".kanban-drop-active").forEach(el =>
        el.classList.remove("kanban-drop-active")
      )
      const zone = e.target.closest(".kanban-drop-zone")
      if (!zone) return

      let data
      try { data = JSON.parse(e.dataTransfer.getData("text/plain")) } catch(_) { return }

      const to = zone.dataset.status
      if (data.from === to) return

      this.pushEvent("move_issue", {
        number: data.number,
        from: data.from,
        to: to,
      })
    })

    // --- Touch drag (mobile) ---
    this.el.addEventListener("touchstart", e => {
      const card = e.target.closest(".kanban-card")
      if (!card || card.dataset.pending === "true") return
      touchDragEl = card
      const touch = e.touches[0]
      touchStartX = touch.clientX
      touchStartY = touch.clientY
      touchStarted = false
    }, { passive: true })

    this.el.addEventListener("touchmove", e => {
      if (!touchDragEl) return
      const touch = e.touches[0]
      const dx = touch.clientX - touchStartX
      const dy = touch.clientY - touchStartY

      if (!touchStarted && Math.sqrt(dx*dx + dy*dy) > 10) {
        touchStarted = true
        const rect = touchDragEl.getBoundingClientRect()
        touchGhost = touchDragEl.cloneNode(true)
        touchGhost.style.cssText = `
          position: fixed; z-index: 1000; pointer-events: none;
          width: ${rect.width}px; opacity: 0.85;
          transform: rotate(2deg); transition: none;
        `
        touchGhost.classList.add("shadow-xl")
        document.body.appendChild(touchGhost)
        touchDragEl.classList.add("opacity-30")
      }

      if (touchStarted && touchGhost) {
        e.preventDefault()
        touchGhost.style.left = (touch.clientX - touchGhost.offsetWidth / 2) + "px"
        touchGhost.style.top = (touch.clientY - 20) + "px"

        const elUnder = document.elementFromPoint(touch.clientX, touch.clientY)
        const zone = elUnder && elUnder.closest(".kanban-drop-zone")
        this.el.querySelectorAll(".kanban-drop-active").forEach(el =>
          el.classList.remove("kanban-drop-active")
        )
        if (zone) zone.classList.add("kanban-drop-active")
      }
    }, { passive: false })

    this.el.addEventListener("touchend", e => {
      if (!touchDragEl || !touchStarted) {
        touchDragEl = null
        return
      }

      if (touchGhost) {
        touchGhost.remove()
        touchGhost = null
      }

      const touch = e.changedTouches[0]
      const elUnder = document.elementFromPoint(touch.clientX, touch.clientY)
      const zone = elUnder && elUnder.closest(".kanban-drop-zone")

      this.el.querySelectorAll(".kanban-drop-active").forEach(el =>
        el.classList.remove("kanban-drop-active")
      )
      touchDragEl.classList.remove("opacity-30")

      if (zone && zone.dataset.status !== touchDragEl.dataset.status) {
        this.pushEvent("move_issue", {
          number: touchDragEl.dataset.number,
          from: touchDragEl.dataset.status,
          to: zone.dataset.status,
        })
      }

      touchDragEl = null
      touchStarted = false
    }, { passive: true })
  }
}
